<template>
  <div class="container">
    <h1>Link is not valid or has expired</h1>
    <p class="gb-text-2">
      <slot>This link is either invalid, or the content is no longer shared by its owner.</slot>
    </p>
    <p class="gb-text-2"><router-link :to="{name: 'Home'}">Goalbook Toolkit</router-link></p>
  </div>
</template>

<script>
export default {
  name: 'ShareLinkInvalidMessage'
}
</script>
